<sfz-header 
  title="OBRIGAÇÕES ACESSÓRIAS" 
  subtitle=""
  #header>
  <div slot="header-actions" class="d-flex flex-row justify-content-between align-items-center gap-2 gap-sm-5">
    <div slot="header-content">
      <div class="usuario-container" style="padding: 16px; text-align: center; color: aliceblue;">
        <ng-container id="usuario-logado" *ngIf="obterUsuario(); else loginMessage">
          Você está logado como <strong>{{ obterUsuario() }}</strong>
        </ng-container>
      </div>

      <ng-template #loginMessage>
        <div class="usuario-container" style="padding: 16px; text-align: center; color: aliceblue;">
          Acesse sua conta
        </div>
      </ng-template>
    </div>
    <sfz-button
      (click)="loginOrLogout()"
      slot="header-actions"
      title="{{ authService.isLoggedIn() ? 'Sair' : 'Entrar' }}"
      startIcon="person"
      type="transparent"
      size="sm">
    </sfz-button>
  </div>
</sfz-header>
